import { useRef, useEffect, useMemo } from 'react'
import { throttle } from 'lodash'

const DEFAULT_WAIT = 2000

function useThrottledCallback(callback, wait = DEFAULT_WAIT) {
  const callbackRef = useRef(callback)
  callbackRef.current = callback

  const throttledFn = useMemo(
    () => throttle((...args) => callbackRef.current(...args), wait, {
      leading: true,
      trailing: true,
    }),
    [wait]
  )

  useEffect(() => {
    return () => {
      throttledFn.cancel()
    }
  }, [throttledFn])

  return throttledFn
}

export default useThrottledCallback
